import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { init } from '../editorconfig';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { getPddFromTemplate } from '../../pre-ready-tepmlate';

@Component({
  selector: 'app-pdd',
  standalone: false,
  templateUrl: './pdd.component.html',
})
export class PddComponent implements OnInit {
  @Input() stepDetails: any;
  init: EditorComponent['init'] = init;
  @Input() commentLabel:string = 'Justification';
  @Input() visibleField: {e:boolean,f:boolean} = {e:true,f:true};
  @Input() url: string;
  @Input() proposalName: any;
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter<any>();
  payload: any;
  editorData: any;
  pddResponse: any;
  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.proposalName = params['name'];
      this.payload['proposal_id'] = params['id'];
      this.payload['proposal_name'] = params['name'];
    });
    if(this.url)
    this.getPDDData();
  }

  getPDDData(): void {
    this.api.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      this.pddResponse = res[0] || res.data;
      this.editorData = this.pddResponse?.comment || getPddFromTemplate(this.stepDetails.code);
    });
  }


  onSubmit(): void {
    if(!this.url) return;
     const payload = {
      comment: this.editorData,
      proposal_step: this.stepDetails?.id,
    };

    const handleResponse = (successMsg: string) => ({
      next: (_: any) => {
           this.messageService.add({    severity: 'success',     summary: 'Success',    detail: successMsg    });
          this.getPDDData();
      }
    });

    const isUpdate = !!(this.pddResponse && this.pddResponse.id);
    if (isUpdate) {
      this.api.putAPI(`${this.url}${this.pddResponse.id}/`, payload)
        .subscribe(handleResponse( this.stepDetails.name + ' updated successfully.' ));
    } else {
      this.api.postAPI(this.url, payload)
        .subscribe(handleResponse( this.stepDetails.name + ' submitted successfully.'));
    }
  }


}
